import styled from 'styled-components';

export const StyledPageContainer = styled.div`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  padding: 40px 24px 48px;
  margin: 0 auto;

  @media (max-width: 600px) {
    padding: 20px 12px 32px;
  }
`;
